<template>
<div class="view-refund-detail">
  <row>
    <div class="sl-col-4" v-loading="fullLoading">
      <div class="sl-form">
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="12">
            <div> <strong>{{$t('Views.RefundDetail.form.trxId')}}:</strong>
              <span>{{form.trxId}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div> <strong>{{$t('Views.RefundDetail.form.cTime')}}:</strong>
              <span>{{form.createTime}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="12">
            <div> <strong>{{$t('Views.RefundDetail.form.ptId')}}:</strong>
              <span>{{form.businessId}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div> <strong>{{$t('Views.RefundDetail.form.pType')}}:</strong>
              <span>{{form.payType}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="12">
            <div> <strong>{{$t('Views.RefundDetail.form.customer')}}:</strong>
              <span>{{form.customer}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div> <strong>{{$t('Views.RefundDetail.form.fee')}}:</strong>
              <span>{{form.serviceFee}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px" class="border-line">
          <el-col :span="24">
            <div> <strong>{{$t('Views.RefundDetail.form.rAmount')}}:</strong>
              <span>{{form.refundAmount}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="24">
            <div>
              <h3>{{$t('Views.RefundDetail.form.settled')}}</h3> </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;" class="border-line">
          <el-col :span="24">
            <div> <strong>{{$t('Views.RefundDetail.form.sTime')}}:</strong>
              <span>{{form.settleTime}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="24">
            <div>
              <h3>{{$t('Views.RefundDetail.form.rComplete')}}: {{form.refundStatusTxt}}</h3> </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="24">
            <div> <strong>{{form.refundStatus == '12' ? $t('Views.RefundDetail.form.failedTime') : $t('Views.RefundDetail.form.completeTime')}}:</strong>
              <span>{{form.modifyTime}}</span>
            </div>
          </el-col>
        </el-row>
        <router-link tag="el-button" :to="{ name: 'Refund' }" @click.native="$ga.event('Link', 'Back', 'Refund details')">{{$t('Functional.back')}}</router-link>
      </div>
    </div>
  </row>
</div>
</template>

<script>
import api from '../../api'
export default {
  name: 'view-refund-detail',
  created() {
    const vm = this
    api.FetchRefundById(this.$route.params.id).then(res => {
      if (res.data.code === 200) {
        vm.form = res.data.data
      }
      vm.fullLoading = false
    })
  },
  data() {
    return {
      fullLoading: true,
      form: {}
    }
  }
}
</script>
<style scoped>
.border-line {
  border-bottom: 1px solid #d7d7d7 !important;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// view-detail.vue?315e4564